import React from 'react';
import { WarningTriangle } from '@withjoy/joykit/icons';
import { Snackbar } from '@shared/components/Snackbar';

type DateMismatchWarningProps = Readonly<{
  /**
   * The already-translated warning copy. Kept as a prop (rather than translated
   * inside this component) so each caller can supply the string from its own
   * i18n namespace.
   */
  message: string;
}>;

/**
 * Warning banner shown when a host's suggested hotel check-in/check-out range
 * doesn't cover the event date. Shared by the Settings and website-editor
 * "Suggested Stay Dates" surfaces.
 */
export const DateMismatchWarning = ({ message }: DateMismatchWarningProps) => (
  <Snackbar
    backgroundColor="warning1"
    icon={WarningTriangle}
  >
    {message}
  </Snackbar>
);
